import { useCallback, useState } from 'react'

export default function useHoverImageSwap(enabled: boolean) {
  const [hovered, setHovered] = useState(false)

  const onMouseEnter = useCallback(() => {
    if (!enabled) return
    setHovered(true)
  }, [enabled])

  const onMouseLeave = useCallback(() => {
    setHovered(false)
  }, [])

  return { hovered, onMouseEnter, onMouseLeave }
}
